import { useState, useEffect, useContext } from "react";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import CircularProgress from "@mui/material/CircularProgress";
// import Typography from "@mui/material/Typography";

import TopAppBar from "../../baseLayout/TopAppBar";
import { useAuthenticated, Loading, Error } from "react-admin";
import { NoEvents, EventsList, NewEventButton } from "../../components";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import IEvent from "../../dataProvider/interfaces/IEvent";
import { useRedirect } from "react-admin";
import { routePaths } from "../../baseLayout/SidebarMenu";
import { StoreContext } from "./../../store/Store";
import { APIContext } from "./../../store/APIStore";
import { IReturnGetEvents } from "./../../dataProvider/services/Event.service";
import FdTypography from "../../components/UIComponents/Typography/FdTypography";
import FdButton from "../../components/UIComponents/Button/FdButton";

const classes = {
  wrapper: {
    paddingLeft: "10%",
    paddingRight: "10%",
    paddingTop: "60px",
    backgroundColor: "#f9f9f9",
    minHeight: "100vh",
  },
} as const;

const ActiveEvents = () => {
  useAuthenticated();
  const redirect = useRedirect();
  const [events, setEvents] = useState<IEvent[]>([]);
  const [loading, setLoading] = useState(true); // page loading
  const [dataLoading, setDataLoading] = useState(false); // data loading
  const [eventsCount, setEventsCount] = useState(0);
  const [error, setError] = useState<string>();
  const [state, dispatch] = useContext(StoreContext);
  const api = useContext(APIContext);

  // update events list when toggling between active/archived
  useEffect(() => {
    loadEvents();
    if (state.selectedEvent) {
      dispatch({ type: "SET_SELECTED_EVENT", payload: null });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // load new events when scrolling at the bottom of the list
  useBottomScrollListener(() => {
    if (events.length < eventsCount) {
      loadEvents(events.length, events);
    }
  });

  const loadEvents = (start?: number, loadedEvents: any[] = []) => {
    setDataLoading(true);
    api.eventService
      .getEvents({
        archived: false,
        start,
      })
      .then(({ data, count }: IReturnGetEvents) => {
        // setEventsList(data.data.flatMap((i: any) => [i, i, i]));
        const newEvents = [...loadedEvents, ...data];
        setLoading(false);
        setDataLoading(false);
        setEvents(newEvents);
        setEventsCount(count);

        // push the fetched active events in store for using them in event selector button
        dispatch({ type: "SET_EVENTS_LIST", payload: newEvents });
      })
      .catch((error: any) => {
        setError(error.response.data.message);
        setLoading(false);
        setDataLoading(false);
      });
  };

  if (error) {
    //@ts-ignore
    return <Error error={{ name: "error", message: error }} />;
  }

  return (
    <>
      {state.eventsList && <TopAppBar />}
      <Box sx={classes.wrapper}>
        {events.length > 0 && (
          <Box pt={10} textAlign="center">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="baseline"
            >
              <FdTypography label="Active Events" variant="h1" component="h1" />
              <Box ml={2} flexGrow={1} textAlign="left">
                <FdButton
                  variant="text"
                  onClick={() => {
                    redirect(`/${routePaths.ARCHIVED_EVENTS}`);
                  }}
                  ButtonName="See archived events"
                />
              </Box>
              <NewEventButton />
            </Box>
            <Divider />
            {!loading && (
              <>
                <EventsList
                  events={events}
                  selectEvent={(event: IEvent) => {
                    // dispatch({ type: "SET_SELECTED_EVENT", payload: event });
                    redirect(
                      `/${routePaths.EVENTS}/${event.id}/${routePaths.EDIT}`
                    );
                  }}
                />
                {dataLoading && (
                  <CircularProgress
                    style={{ marginTop: "20px", marginBottom: "20px" }}
                  />
                )}
              </>
            )}
            {loading && <Loading />}
          </Box>
        )}
        {!loading && events.length === 0 && <NoEvents />}
        {loading && events.length === 0 && <Loading />}
      </Box>
    </>
  );
};

export default ActiveEvents;
